import blog1 from '../assets/images/blog1.jpg'
import blog2 from '../assets/images/blog2.jpg'
import blog3 from '../assets/images/blog4.jpg'

export const blogData = [
    {
        id: 1,
        image: blog1,
        user: "admin",
        service: "service",
        name: "Common Engine Oil Problems and Solutions",
        date: "Jun 24, 2023",
        button: "read more"
    },
    {
        id: 2,
        image: blog2,
        user: "admin",
        service: "service",
        name: "Common Engine Oil Problems and Solutions",
        date: "Jun 24, 2023",
        button: "read more"
    },
    {
        id: 3,
        image: blog3,
        user: "admin",
        service: "service",
        name: "Common Engine Oil Problems and Solutions",
        date: "Jun 24, 2023",
        button: "read more"
    },
]